import {
  GoogledLyricsSourceLocation,
  OpenAiSourceLocation,
  SourceLocation,
  SourceLocationType,
  TextSourceLocation,
  YoutubeSourceLocation,
} from "../api-generated";

export type Offset = {
  left: number;
  right: number;
  top: number;
};

//TODO: hmmm, atow making this to be able to
//easily pass down through component props
//this info to be able to invalidate cache...
//really, components shouldn't have to know what
//cache should be invalidated...
//although, atow Word.tsx does need sourceId
//to say_what for that source

export const getUniqueLocationId = (sourceLocation: SourceLocation): string => {
  if (sourceLocation.type === SourceLocationType.youtube) {
    const youtubeLocation: YoutubeSourceLocation =
      sourceLocation as YoutubeSourceLocation;
    return toQueryParamString(youtubeLocation);
  }

  if (sourceLocation.type === SourceLocationType.openai_chat) {
    const openAiLocation: OpenAiSourceLocation =
      sourceLocation as OpenAiSourceLocation;
    return toQueryParamString(openAiLocation);
  }

  if (sourceLocation.type === SourceLocationType.googled_lyrics) {
    const lyricsLocation: GoogledLyricsSourceLocation =
      sourceLocation as GoogledLyricsSourceLocation;
    return toQueryParamString(lyricsLocation);
  }

  if (sourceLocation.type === SourceLocationType.text_page) {
    const textLocation: TextSourceLocation =
      sourceLocation as TextSourceLocation;
    return toQueryParamString(textLocation);
  }

  throw new Error("source type not supported");
};

//NB: this isn't an actual query param string - it doesn't do encoding needed for
//browser/http urls
function toQueryParamString<T extends Record<string, any>>(params: T): string {
  return Object.entries(params)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
}
